import { useMemo, useRef } from "react";
import { useFrame } from "@react-three/fiber";
import * as THREE from "three";

function pseudoRandom(seed: number): number {
  return ((Math.sin(seed) * 43758.5453) % 1 + 1) % 1;
}

interface BubbleData {
  radius: number;
  opacity: number;
  speed: number;
  wobbleOffset: number;
  startX: number;
  startY: number;
  startZ: number;
}

export function Bubbles() {
  const meshRefs = useRef<(THREE.Mesh | null)[]>(new Array(25).fill(null));

  const bubbles = useMemo<BubbleData[]>(() => {
    return Array.from({ length: 25 }, (_, i) => {
      const angle = pseudoRandom(i * 1.1) * Math.PI * 2;
      const dist = pseudoRandom(i * 2.2) * 7;
      return {
        radius: 0.04 + pseudoRandom(i * 3.3) * 0.06,
        opacity: 0.3 + pseudoRandom(i * 4.4) * 0.3,
        speed: 0.2 + pseudoRandom(i * 5.5) * 0.4,
        wobbleOffset: pseudoRandom(i * 6.6) * Math.PI * 2,
        startX: Math.cos(angle) * dist,
        startY: 1 + pseudoRandom(i * 7.7) * 6,
        startZ: Math.sin(angle) * dist,
      };
    });
  }, []);

  useFrame(({ clock }) => {
    const t = clock.elapsedTime;
    for (let i = 0; i < 25; i++) {
      const mesh = meshRefs.current[i];
      if (!mesh) continue;
      const b = bubbles[i];

      mesh.position.y += b.speed * 0.008;
      mesh.position.x += Math.sin(t * 0.5 + b.wobbleOffset) * 0.003;
      mesh.position.z += Math.cos(t * 0.3 + b.wobbleOffset) * 0.003;

      if (mesh.position.y > 8) {
        mesh.position.y = 0.5;
        mesh.position.x = b.startX;
        mesh.position.z = b.startZ;
      }
    }
  });

  return (
    <>
      {bubbles.map((b, i) => (
        <mesh
          key={i}
          ref={(el) => { meshRefs.current[i] = el; }}
          position={[b.startX, b.startY, b.startZ]}
        >
          <sphereGeometry args={[b.radius, 6, 4]} />
          <meshStandardMaterial
            color="#FFFFFF"
            transparent
            opacity={b.opacity}
            flatShading
          />
        </mesh>
      ))}
    </>
  );
}
